import React from 'react';

export default function ErrorPage() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <h1>404 - Not Found!</h1>
    </div>
  );
}
